/*
 * Define a form page to display a list of Healthcare Program Types.
 */
import css from '../../../ComplaintForm/ComplaintForm.module.css'
import { convertHashToChoiceArray } from '../../../../choices'
import { healthcare_programs } from 'hotline_complaint_choices'
import { otherChoicePage } from '../../../../pages'

export const programTypePage = propOverrides => {
  const props = {
    pageId: 'hhs_program_type_page',
    fieldName: 'hhs_program_type',
    choices: convertHashToChoiceArray(healthcare_programs),
    label: 'Which type of program does this relate to?',
    className: css.choices,
    labelClassName: css.largeLabel,
    fieldNameOther: 'hhs_program_type_other',
    labelOther: 'Please enter the program type',
    ...propOverrides
  }

  return otherChoicePage({ ...props })
}
